import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { SHIPMENT } from '../constants/fulfillment-types';
import { emptyArray } from 'ui-components/default-props/empty';

export const useHasShippedFromFulfillmentPlanId = (fulfillmentPlanId) => {
  const fulfillmentPlan = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }));
  const fulfillmentIds = fulfillmentPlan?.fulfillmentIds;
  const fulfillments = useSelector((state) => Global.selectEntitiesFulfillmentsByIds(state, { fulfillmentIds })) || emptyArray;
  const hasShipped = useMemo(() => {
    if (fulfillments.length === 0) {
      return false;
    }
    const shipments = fulfillments.filter((f) => f.fulfillmentType === SHIPMENT && !f.isLabelVoided);
    return shipments.some((s) => !s.isVoided);
  }, [fulfillments]);
  return hasShipped;
};
